// extracted by mini-css-extract-plugin
export default {"header":"Notice_header__Y-98S","noticeList":"Notice_noticeList__aZ6qb","noData":"Notice_noData__2Wb8v"};